export default __webpack_public_path__ + "static/media/streetlightsLogo.28a7e5c5.svg";